import resolvePromise from '../helper/resolved_promise';
import { CatalogPromotionsActions } from '../constants/catalog_promotions/catalog_promotions_actions';
import Dispatcher from '../dispatcher';

function setCatalogPromotionsAction(promotions) {
    Dispatcher.handleCatalogPromotionsAction({
        type: CatalogPromotionsActions.SET_PROMOTIONS,
        payload: promotions
    });

    return resolvePromise();
}

function loadingCatalogPromotionsAction() {
    Dispatcher.handleCatalogPromotionsAction({
        type: CatalogPromotionsActions.LOAD_CATALOG_PROMOTIONS_ACTION
    });

    return resolvePromise();
}

function setCatalogPromotionsBuyerAssistUrl(url) {
    Dispatcher.handleCatalogPromotionsAction({
        type: CatalogPromotionsActions.SET_BUYER_ASSIST_URL,
        payload: url
    });

    return resolvePromise();
}

export {
    setCatalogPromotionsAction,
    loadingCatalogPromotionsAction,
    setCatalogPromotionsBuyerAssistUrl,
};